export default function CTASection() {
  const handleContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e06d6e88e08784d85def7adf81832a9a.jpg"
          alt="Công trình xây dựng"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0E5C3A]/80"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <span className="inline-flex items-center gap-2 bg-white/15 text-white/90 text-sm font-medium px-4 py-1.5 rounded-full mb-6">
          <i className="ri-shake-hands-line"></i>
          Hợp tác cùng chúng tôi
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
          Đối tác tin cậy cho mọi<br />
          <span className="text-[#D4A017]">công trình xây dựng</span> của bạn
        </h2>
        <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto">
          Liên hệ ngay để được tư vấn miễn phí về các dịch vụ thí nghiệm vật liệu xây dựng 
          phù hợp với yêu cầu công trình của bạn.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={handleContact}
            className="inline-flex items-center justify-center gap-2 bg-[#D4A017] text-white px-8 py-4 rounded-md font-bold text-base hover:bg-[#B8891A] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill"></i>
            Liên hệ ngay
          </button>
          <a
            href="tel:02366517174"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-8 py-4 rounded-md font-bold text-base hover:bg-white hover:text-[#0E5C3A] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            0236.6517174
          </a>
        </div>

        {/* Feature row */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 mt-14">
          {[
            { icon: "ri-time-line", label: "Kết quả nhanh chóng" },
            { icon: "ri-shield-check-line", label: "Độ chính xác cao" },
            { icon: "ri-file-list-3-line", label: "Báo cáo đúng chuẩn" },
            { icon: "ri-customer-service-2-line", label: "Hỗ trợ kỹ thuật" },
          ].map((f) => (
            <div key={f.label} className="flex items-center gap-2 text-white/90">
              <div className="w-8 h-8 flex items-center justify-center text-[#D4A017]">
                <i className={`${f.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium">{f.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
